var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3512 3982 c-25 -109 -58 -194 -96 -253 -54 -81 -175 -143 -346 -179 -83 -17 -84 -17 -45 -24 157 -29 292 -85 354 -148 65 -64 96 -139 146 -353 7 -26 10 -20 25 50 36 159 94 277 163 329 66 49 202 99 332 121 39 7 38 8 -45 25 -296 61 -390 154 -449 445 l-17 85 -22 -98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 3727 c-43 -15 -80 -68 -80 -116 0 -146 210 -176 249 -36 10 36 9 44 -11 97 -19 52 -94 78 -158 55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2171 3291 c-3 -57 -56 -286 -93 -400 -107 -332 -227 -466 -517 -583 -104 -43 -277 -89 -421 -113 -96 -17 -123 -25 -79 -25 13 0 78 -11 144 -25 405 -84 635 -209 757 -410 79 -131 158 -370 194 -589 l18 -110 21 120 c76 410 200 660 393 787 134 89 361 168 602 210 l125 22 -75 12 c-232 40 -425 99 -575 176 -257 133 -385 367 -479 877 -7 41 -14 64 -15 51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3575 1497 c-41 -41 -52 -90 -32 -140 19 -44 54 -68 110 -74 88 -10 155 77 128 167 -16 53 -58 80 -124 80 -42 0 -54 -5 -82 -33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStars);
export default __webpack_public_path__ + "static/media/ai_stars.2682a122b88ef3a7dc3ecf9d80e3572b.svg";
export { ForwardRef as ReactComponent };